import CoreuiController from "../lib/coreui-controller"
import SearchButton from "../coreui/search_button"

export default class CoreuiSearchButtonController extends CoreuiController {
  static Component = SearchButton
}
